<template>
  <v-card
    class="no-select m-2"
    elevation="2"
    rounded="xl"
    dir="rtl"
    height="421"
    color="white"
    style="width: 100%; max-width: 300px; box-sizing: border-box"
    @mouseenter="hover = true"
    @mouseleave="hover = false"
  >
    <template #loader="{ isActive }">
      <v-progress-linear
        :active="isActive"
        color="deep-purple"
        height="2"
        indeterminate
      />
    </template>

    <v-card-text class="pa-0" style="min-height: 3rem">
      <!-- :style="imgStyle"
        class="transition-fast" -->
      <swiper-wrapper
        v-if="shopDetails.images && shopDetails.images.length > 0"
        :wrapperClass="'shop-swiper'"
        :autoplay="true"
        :slidesPerView="1"
        :spaceBetween="10"
        :showArrows="true"
      >
        <template #default>
          <div
            class="swiper-slide"
            v-for="(img, index) in shopDetails.images"
            :key="index"
            style="display: flex; justify-content: center"
          >
            <img
              :src="img.url"
              :style="{
                width: '100%',
                height: '300px',
                borderRadius: '8px',
                objectFit: 'cover',
              }"
            />
          </div>
        </template>
      </swiper-wrapper>

      <v-img v-else height="250" :src="fallbackImage" cover />
    </v-card-text>

    <v-card-title
      class="text-center"
      color="black"
      style="color: black; display: flex; justify-content: center"
    >
      {{ shopDetails?.setting?.organizationName }}
    </v-card-title>

    <v-card-subtitle color="black" class="text-center black--text">
      {{ shopDetails?.subtitle }}
    </v-card-subtitle>

    <v-card-actions
      style="position: absolute; bottom: 0"
      height="48"
      class="pa-0 w-100"
    >
      <v-btn
        block
        height="48"
        :href="`http://my.qrland.ir/${info.url}`"
        target="_blank"
        class="w-100"
        style="
          opacity: 0.8;
          border-bottom-right-radius: 15px;
          border-bottom-left-radius: 15px;
        "
        :color="
          colorButton?.background?.length > 0 ? colorButton?.background : ''
        "
        :style="{
          background:
            colorButton?.background?.length > 0 ? colorButton?.background : '',
          color: colorButton?.color?.length > 0 ? colorButton?.color : 'white',
        }"
      >
        {{ shopDetails?.alias }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import swiperWrapper from "./swiperWrapper.vue";
export default {
  components: { swiperWrapper },
  name: "bFloorShop",
  props: {
    details: {
      type: Object,
      default: () => ({}),
    },
    shopDetails: Object,
  },
  data() {
    return {
      hover: false,
      medias: [],
      info: {
        url: "",
        title: "",
        subtitle: "",
        images: null,
        tags: [],
        socialMedia: {},
      },
    };
  },
  computed: {
    // computedImageSrc() {
    //   if (Array.isArray(this.info.images) && this.info.images.length > 0) {
    //     return this.info.images[0];
    //   } else if (
    //     typeof this.info.images === "string" &&
    //     this.info.images.length > 0
    //   ) {
    //     return this.info.images;
    //   } else {
    //     return "/placeholder.png";
    //   }
    // },
    // imgStyle() {
    //   return {
    //     transform: this.hover ? "scale(1.1)" : "scale(1)",
    //     filter: this.hover ? "brightness(0.5)" : "brightness(1)",
    //     transition: "transform 0.2s ease, filter 0.2s ease",
    //   };
    // },
    ...mapState("local", ["qr_id", "qrInfo"]),

    colorButton() {
      const colors = this.qrInfo?.pallete;

      return {
        background: colors?.headColor.length > 0 ? colors?.headColor : "blue",
        color: colors?.textColor.length > 0 ? colors?.textColor : "white",
      };
    },
    fallbackImage() {
      if (this.shopDetails.images && this.shopDetails.images.length === 1) {
        return this.shopDetails.images[0].url;
      }
      return "/placeholder.jpg"; // عکس پیش‌فرضت
    },
  },
  watch: {
    details: {
      immediate: true,
      deep: true,
      handler(newDetails) {
        if (!newDetails) return;
        this.info.url = newDetails.url || "";
        this.info.title = newDetails.data?.organizationName || "";
        this.info.images =
          (newDetails.data?.banner?.gallery &&
            newDetails.data.banner.gallery[0]?.images) ||
          newDetails.data?.photo?.headBackground ||
          null;
        this.info.subtitle = newDetails.data?.subOrgan || "";
        this.info.socialMedia = newDetails.data?.socialMedia || {};
        this.medias = [];
        this.getMedia();
      },
    },
  },
  methods: {
    getMedia() {
      if (!this.info.socialMedia) return;
      Object.keys(this.info.socialMedia).forEach((key) => {
        this.medias.push({ name: key, media: this.info.socialMedia[key] });
      });
    },
  },
};
</script>

<style scoped>
.no-select {
  user-select: none;
  cursor: default;
}

.v-card.no-select:active,
.v-card.no-select:focus {
  background-color: inherit !important;
  box-shadow: none !important;
}

.transition-fast {
  transition: transform 0.2s ease, filter 0.2s ease;
}
</style>
